module.exports = __webpack_public_path__ + "img/VOMS-screen.a55ab180.png";